import { PostPageShell } from "@/components/blog/PostPageShell";
import { PublicRoutes } from "@/constants/routes";
import { Button, Heading, Text } from "@/design-system";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router";

/**
 * Post inexistente, despublicado ou com slug trocado.
 *
 * Fica na própria URL (nada de redirecionar) com `noindex, follow`: o buscador
 * precisa ver o status da página que pediu, e o `follow` mantém os links da
 * página valendo.
 */
export const PostNotFound = () => (
  <>
    <Helmet>
      <title>Post não encontrado</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <PostPageShell width="narrow">
      <Text size="small" tone="brand" weight="semibold">
        Erro 404
      </Text>
      <Heading level={1} size={2}>
        Não encontramos este post
      </Heading>
      <Text tone="muted">
        O conteúdo pode ter sido movido ou despublicado. Veja os artigos disponíveis no blog.
      </Text>
      <Button asChild navigates="internal" className="mt-2">
        <Link to={PublicRoutes.BLOG}>Ver todos os conteúdos</Link>
      </Button>
    </PostPageShell>
  </>
);
